import React, { useState, useEffect } from "react";
import {
  LoginPayloadType,
  LoginWithMobileNumberPayloadType,
  LoginWithMobileOtpVerifyPayloadType,
} from "../../commonTypes/authTypes";
import { LoginCard } from "../../components/Login";
import { connect, useDispatch } from "react-redux";
import {
  loginUserAction,
  resetAuthSuccess,
  resetAuthError,
  resetSession,
  forgetPasswordAction,
  loginWithMobileNumberAction,
  loginWithMobileOtpVerifyAction,
  resetPersistUserProfileAllData,
  setLocationDetails,
  resetLocationDetails,
} from "../../redux/auth";
import { RootState } from "../../redux/rootReducers";
import { convertPasswordToHash } from "../../utils/commonFunctions";
import { Loader, ErrorSuccessModal } from "../../components/commons";
import toast, { Toaster } from "react-hot-toast";
import { GetMaintenanceTypes } from "../../redux/maintenance/maintenanceTypes";
import ScheduledBanner from "../ScheduleMaintenance/ScheduledBanner";
import { getMaintenanceDataAction } from "../../redux/maintenance";
import axios from "axios";
import { Helmet } from "react-helmet";

type AppProps = {
  history: any;
  success: number | null;
  fetching: boolean;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  isMaintenance?: number;
  maintenanceData?: GetMaintenanceTypes;
  dispatchLoginUserAction: (data: LoginPayloadType) => void;
  dispatchLoginWithMobileNumberAction: (
    data: LoginWithMobileNumberPayloadType
  ) => void;
  dispatchLoginWithMobileOtpVerifyAction: (
    data: LoginWithMobileOtpVerifyPayloadType
  ) => void;
  dispatchGetMaintenanceDataAction: () => void;
  dispatchForgetPasswordAction: (email: string) => void;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetSessionAction: () => void;
  dispatchResetLocationDetails: () => void;
  dispatchResetPersistUserProfileAllData: () => void;
  dispatchSetLocationDetails: (data: any) => void;
};

const Login = ({
  history,
  dispatchLoginUserAction,
  dispatchForgetPasswordAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetSessionAction,
  dispatchResetPersistUserProfileAllData,
  dispatchGetMaintenanceDataAction,
  statusCode,
  fetching,
  error,
  success,
  message,
  isMaintenance,
  maintenanceData,
  dispatchLoginWithMobileNumberAction,
  dispatchLoginWithMobileOtpVerifyAction,
  dispatchSetLocationDetails,
  dispatchResetLocationDetails,
}: AppProps) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [submit, setSubmit] = useState(false);
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });


  const dispatchAction = useDispatch();

  useEffect(() => {
    dispatchGetMaintenanceDataAction();
    dispatchAction(resetAuthError());
    dispatchAction(resetAuthSuccess());
  }, []);

 

  const handleLoginUser = async (data: LoginPayloadType) => {
    dispatchResetLocationDetails();
    let finalPassword = await convertPasswordToHash(data.password);
    dispatchResetPersistUserProfileAllData();
    let finalData = {
      email: data?.email,
      password: finalPassword,
    };
    setLoginData({
      email: data?.email,
      password: data?.password,
    });
    dispatchLoginUserAction(finalData);
  };

  const handleForgetPassword = async (email: string) => {
    dispatchForgetPasswordAction(email);
    setSubmit(true);
    setSuccessMessage("Reset password link sent successfully to your mail!");
  };

  const handleMobileOtpSend = async (
    data: LoginWithMobileNumberPayloadType
  ) => {
    dispatchLoginWithMobileNumberAction(data);
  };

  const handleMobileOtpVerify = async (
    data: LoginWithMobileOtpVerifyPayloadType
  ) => {
    dispatchLoginWithMobileOtpVerifyAction(data);
  };

  const handleErrorSuccessModal = () => {
    if (success === 0) {
      if (error && statusCode !== 401) {
        if (loginData?.email && loginData?.password) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!error}
              title="Error"
              message={error}
              buttonText="Try Again"
              onPress={() => dispatchResetAuthError()}
              statusCode={statusCode}
            />
          );
        } else if (
          error?.includes(
            "Maximum reset password limit exceeded. Please try after 15-minutes"
          )
        ) {
          dispatchResetAuthSuccess();
          toast.error(error, {
            duration: 2000,
          });
        } else {
          dispatchResetAuthSuccess();
          toast.error(error, {
            duration: 2000,
          });
        }
        if (submit) {
          dispatchResetAuthSuccess();
        }
      }
    }
    if (success === 1) {
      if (submit) {
        toast.success(successMessage, {
          duration: 2000,
        });
        dispatchResetAuthSuccess();
      } else if (
        message?.includes("OTP sent successfully to your mobile number!")
      ) {
        dispatchResetAuthSuccess();
        toast.success("The OTP has been sent successfully to your mobile.", {
          duration: 2000,
        });
      }
    }

    return false;
  };

  return (
    <>
      <Helmet>
        <title>FINAC by Akssai ProjExel</title>
      </Helmet>
      <>
        {isMaintenance === 1 && (
          <ScheduledBanner maintenanceData={maintenanceData} />
        )}
      </>
      <LoginCard
        history={history}
        error={error}
        success={success}
        passwordErrorr={passwordError}
        handleLoginUser={handleLoginUser}
        handleForgetPassword={handleForgetPassword}
        handleMobileOtpVerify={handleMobileOtpVerify}
        handleMobileOtpSend={handleMobileOtpSend}
      />
      {fetching && <Loader />}
      {handleErrorSuccessModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  success: state.auth.success,
  message: state.auth.message,
  fetching: state.auth.fetching,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  isMaintenance: state.maintenance.isMaintenance,
  maintenanceData: state.maintenance.maintenanceData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLoginUserAction: (data: LoginPayloadType) =>
    dispatch(loginUserAction(data)),

  dispatchLoginWithMobileNumberAction: (
    data: LoginWithMobileNumberPayloadType
  ) => dispatch(loginWithMobileNumberAction(data)),
  dispatchGetMaintenanceDataAction: () => dispatch(getMaintenanceDataAction()),
  dispatchLoginWithMobileOtpVerifyAction: (
    data: LoginWithMobileOtpVerifyPayloadType
  ) => dispatch(loginWithMobileOtpVerifyAction(data)),

  dispatchForgetPasswordAction: (email: string | null) =>
    dispatch(forgetPasswordAction(email)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchResetLocationDetails: () => dispatch(resetLocationDetails()),
  dispatchResetPersistUserProfileAllData: () =>
    dispatch(resetPersistUserProfileAllData()),
  dispatchSetLocationDetails: (data: any) => dispatch(setLocationDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
